import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAvXjATSNgwOvPXMbjasSgUMb7TOTd5ZnE",
  authDomain: "aio-robot.firebaseapp.com",
  projectId: "aio-robot",
  storageBucket: "aio-robot.appspot.com",
  messagingSenderId: "566464678886",
  appId: "1:566464678886:web:be61fc30cc648c568ea427",
  measurementId: "G-MTBC8P9TPK"
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);


// Initialize Cloud Firestore and get a reference to the service
export const firebaseDb = getFirestore(firebaseApp);
